/*
  Reinitializes the meal filter drawer, checkbox filters, and global map filter.
  - Drawer + checkbox filters are scoped to each .option_grid
  - Map filter is global because #states-mapper and the SVG map live in map-filter-section.liquid
*/

(function () {
  if (window.__facetsDetailsInitRegistered) return;
  window.__facetsDetailsInitRegistered = true;

  function getOptionGrid(container) {
    if (!container) return null;
    if (container.classList && container.classList.contains('option_grid')) return container;
    return container.closest('.option_grid');
  }

  function getSelectedFilters(scope) {
    const filters = {};

    scope.querySelectorAll('.wrapper--filter-values input[type="checkbox"]:checked').forEach((checkbox) => {
      const name = checkbox.name.replace('[]', '');
      if (!filters[name]) {
        filters[name] = [];
      }

      filters[name].push(checkbox.value.trim());
    });

    return filters;
  }

  /* ---- Toggle filter keys (boolean metafield filters) ---- */
  var TOGGLE_FILTER_KEYS = ['breakfast', 'gluten_free', 'low_carb', 'weight_loss', 'high_protein', 'hall_of_fame', 'heart_healthy', 'low_cholesterol', 'glp_1', 'high_fiber'];

  function updateURL(filters) {
    const params = new URLSearchParams(window.location.search);

    ['protein', 'kcal', 'fat', 'carbs', 'lifestyle'].forEach((key) => {
      params.delete(key);
    });

    // Clear toggle filter params
    TOGGLE_FILTER_KEYS.forEach((key) => {
      params.delete(key);
    });

    Object.keys(filters).forEach((key) => {
      if (filters[key].length) {
        params.set(key, filters[key].join(','));
      }
    });

    // Write active toggle filters to URL
    var activeToggles = getActiveToggleFilters();
    activeToggles.forEach((key) => {
      params.set(key, 'true');
    });

    const query = params.toString();
    const newUrl = query ? `${window.location.pathname}?${query}` : window.location.pathname;
    window.history.replaceState({}, '', newUrl);
  }

  function filterCardByCheckboxes(card, filters) {
    return Object.keys(filters).every((filterName) => {
      const selectedValues = filters[filterName];
      if (!selectedValues.length) return true;

      if (filterName === 'lifestyle') {
        return selectedValues.some((value) => {
          return (
            (value === 'glp1' && card.dataset.glp1 === 'glp1') ||
            (value === 'weight-loss' && card.dataset.weightLoss === 'weight-loss') ||
            (value === 'xl' && card.dataset.xl === 'xl') ||
            (value === 'highly-rated' &&
              (card.dataset.rated === 'highly-rated' || card.dataset.rating === 'highly-rated'))
          );
        });
      }

      const cardValue = (card.dataset[filterName] || '').trim();
      return selectedValues.includes(cardValue);
    });
  }

  function filterCardByWarehouse(card) {
    const selectedWarehouse = document.body.dataset.selectedWarehouse || '';
    if (!selectedWarehouse) return true;

    const warehouses = (card.dataset.warehouse || '').trim().split(/\s+/).filter(Boolean);
    return warehouses.includes(selectedWarehouse);
  }

  function applyCombinedFilters(scope) {
    if (!scope) return;

    const filters = getSelectedFilters(scope);
    const activeToggles = getActiveToggleFilters();
    const mealCards = scope.querySelectorAll('[data-meal-card]');
    const noMealsMsg = scope.querySelector('.no-meals-message');
    let visibleCount = 0;

    mealCards.forEach((card) => {
      const matchesCheckboxes = filterCardByCheckboxes(card, filters);
      const matchesWarehouse = filterCardByWarehouse(card);
      const matchesToggles = filterCardByToggles(card, activeToggles);
      const shouldShow = matchesCheckboxes && matchesWarehouse && matchesToggles;

      card.style.display = shouldShow ? 'block' : 'none';
      card.classList.toggle('is-hidden', !shouldShow);

      if (shouldShow) {
        visibleCount += 1;
      }
    });

    if (noMealsMsg) {
      noMealsMsg.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    updateURL(filters);
  }

  function restoreFromURL(scope) {
    const params = new URLSearchParams(window.location.search);

    params.forEach((value, key) => {
      value.split(',').forEach((item) => {
        const checkbox = scope.querySelector(`input[name="${key}[]"][value="${item}"]`);
        if (checkbox) {
          checkbox.checked = true;
        }
      });
    });

    applyCombinedFilters(scope);
  }

  function bindFilterDrawer(scope) {
    const btn = scope.querySelector('.gateway-header');
    const panel = scope.querySelector('.custom-filter');
    const overlay = scope.querySelector('.custom-filter-overlay');
    const closeBtn = scope.querySelector('#filter_close');

    if (!btn || !panel || !overlay) return;
    if (panel.dataset.drawerBound === 'true') return;

    const toggleFilter = (isOpen) => {
      panel.classList.toggle('active', isOpen);
      overlay.classList.toggle('active', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    };

    btn.addEventListener('click', () => toggleFilter(true));
    overlay.addEventListener('click', () => toggleFilter(false));

    if (closeBtn) {
      closeBtn.addEventListener('click', () => toggleFilter(false));
    }

    panel.dataset.drawerBound = 'true';
  }

  function bindCheckboxFilters(scope) {
    if (!scope || scope.dataset.checkboxFiltersBound === 'true') {
      if (scope) {
        applyCombinedFilters(scope);
      }
      return;
    }

    scope.addEventListener('change', (event) => {
      if (!event.target.matches('.wrapper--filter-values input[type="checkbox"]')) return;
      applyCombinedFilters(scope);
    });

    scope.dataset.checkboxFiltersBound = 'true';
    restoreFromURL(scope);
  }

  function scrollToMealGrid() {
    const mealSection = document.querySelector('.meal-tabs');
    if (!mealSection) return;

    const yOffset = -10;
    const y = mealSection.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }

  // ---- ATC Location Lock ----

  function isWarehouseSelected() {
    return !!(document.body.dataset.selectedWarehouse || '').trim();
  }

  function scrollToMap() {
    const mapSection = document.querySelector('.build-your-meal-map');
    if (!mapSection) return;
    const y = mapSection.getBoundingClientRect().top + window.pageYOffset - 20;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function showMapTooltip() {
    const existing = document.getElementById('map-location-tooltip');
    if (existing) existing.remove();

    const tooltip = document.createElement('div');
    tooltip.id = 'map-location-tooltip';
    tooltip.textContent = 'Please Choose a State to see Your Local Meals';
    tooltip.setAttribute('role', 'alert');
    tooltip.setAttribute('aria-live', 'polite');
    document.body.appendChild(tooltip);

    setTimeout(() => {
      if (tooltip.parentNode) tooltip.remove();
    }, 3500);
  }

  function updateAddToCartLockState() {
    const locked = !isWarehouseSelected();
    document.body.classList.toggle('atc-location-locked', locked);
  }

  function bindAtcLockInterceptor() {
    if (document.body.dataset.atcInterceptorBound === 'true') return;
    document.body.dataset.atcInterceptorBound = 'true';

    document.addEventListener(
      'click',
      function (event) {
        if (!document.body.classList.contains('atc-location-locked')) return;

        const target = event.target;
        if (
          target.closest('.add-to-cart-btn') ||
          target.closest('.quantity__button.plus') ||
          target.closest('.meal-builder__cta')
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
          scrollToMap();
          showMapTooltip();
        }
      },
      true
    );
  }

  window.updateAtcLockState = updateAddToCartLockState;

  // ---- End ATC Location Lock ----

  function applyMapFilter(stateCode) {
    const normalizedCode = (stateCode || '').toString().trim().toUpperCase();
    let selectedWarehouse = '';

    document.querySelectorAll('[class*="sm_state_"]').forEach(function (state) {
      state.classList.remove('state-active');
    });
    document.querySelectorAll('[class*="sm_label_"]').forEach(function (label) {
      label.classList.remove('state-active');
    });

    if (normalizedCode) {
      var targetState = document.querySelector('.sm_state_' + normalizedCode);

      if (targetState) {
        targetState.classList.add('state-active');
        selectedWarehouse = targetState.dataset.warehouse || '';
      }

      document.querySelectorAll('.sm_label_' + normalizedCode).forEach(function (label) {
        label.classList.add('state-active');
      });
    }

    document.body.dataset.selectedWarehouse = selectedWarehouse;
    updateAddToCartLockState();
    document.dispatchEvent(new CustomEvent('warehouse:changed', { detail: { warehouse: selectedWarehouse } }));

    document.querySelectorAll('.option_grid').forEach((scope) => {
      applyCombinedFilters(scope);
    });

    scrollToMealGrid();
  }

  function syncMiniStateAttributes() {
    document.querySelectorAll('[class*="sm_label_"]').forEach(function (label) {
      var classList = label.className.baseVal || label.className;
      var match = classList.match(/sm_label_([A-Z]+)/);
      if (!match || !match[1]) return;

      var stateCode = match[1];
      var statePath = document.querySelector('.sm_state_' + stateCode);
      if (!statePath) return;

      var attrs = ['class', 'warehouse', 'ship'];
      for (var i = 0; i < attrs.length; i++) {
        var val = statePath.dataset[attrs[i]];
        if (val && !label.dataset[attrs[i]]) {
          label.dataset[attrs[i]] = val;
        }
      }

      label.dataset.state = stateCode;
    });
  }

  function bindMapFilter() {
    var input = document.getElementById('states-mapper');
    var button = document.querySelector('.map-file-states button');

    if (!input || !button || button.dataset.mapBound === 'true') return;

    syncMiniStateAttributes();

    button.addEventListener('click', function (event) {
      event.preventDefault();
      applyMapFilter(input.value);
    });

    document.querySelectorAll('[class*="sm_state_"]').forEach(function (state) {
      if (state.dataset.mapBound === 'true') return;

      state.addEventListener('click', function () {
        var classList = this.className.baseVal || this.className;
        var match = classList.match(/sm_state_([A-Z]+)/);

        if (match && match[1]) {
          input.value = match[1];
          applyMapFilter(match[1]);
        }
      });

      state.dataset.mapBound = 'true';
    });

    document.querySelectorAll('[class*="sm_label_"]').forEach(function (label) {
      if (label.dataset.mapBound === 'true') return;

      label.addEventListener('click', function () {
        var classList = this.className.baseVal || this.className;
        var match = classList.match(/sm_label_([A-Z]+)/);

        if (match && match[1]) {
          input.value = match[1];
          applyMapFilter(match[1]);
        }
      });

      label.dataset.mapBound = 'true';
    });

    button.dataset.mapBound = 'true';
  }

  /* ========================================
     Toggle (boolean metafield) filter logic
     ======================================== */

  function getActiveToggleFilters() {
    var active = [];
    document.querySelectorAll('.toggle-filter-btn.is-active').forEach(function (btn) {
      var key = btn.getAttribute('data-filter-key');
      if (key && key !== 'all') {
        active.push(key);
      }
    });
    return active;
  }

  function filterCardByToggles(card, activeToggles) {
    if (!activeToggles.length) return true; // "All" or nothing selected
    return activeToggles.every(function (key) {
      return card.getAttribute('data-filter-' + key) === 'true';
    });
  }

  function applyCombinedFiltersWithToggles(scope) {
    if (!scope) return;

    var filters = getSelectedFilters(scope);
    var activeToggles = getActiveToggleFilters();
    var mealCards = scope.querySelectorAll('[data-meal-card]');
    var noMealsMsg = scope.querySelector('.no-meals-message');
    var visibleCount = 0;

    mealCards.forEach(function (card) {
      var matchesCheckboxes = filterCardByCheckboxes(card, filters);
      var matchesWarehouse = filterCardByWarehouse(card);
      var matchesToggles = filterCardByToggles(card, activeToggles);
      var shouldShow = matchesCheckboxes && matchesWarehouse && matchesToggles;

      card.style.display = shouldShow ? 'block' : 'none';
      card.classList.toggle('is-hidden', !shouldShow);

      if (shouldShow) {
        visibleCount += 1;
      }
    });

    if (noMealsMsg) {
      noMealsMsg.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    updateURL(filters);
  }

  function updateToggleButtonStates() {
    var activeToggles = getActiveToggleFilters();
    var allBtn = document.querySelector('.toggle-filter-btn[data-filter-key="all"]');
    if (allBtn) {
      allBtn.classList.toggle('is-active', activeToggles.length === 0);
    }
  }

  function restoreTogglesFromURL() {
    var params = new URLSearchParams(window.location.search);
    var anyToggleActive = false;

    TOGGLE_FILTER_KEYS.forEach(function (key) {
      if (params.get(key) === 'true') {
        var btn = document.querySelector('.toggle-filter-btn[data-filter-key="' + key + '"]');
        if (btn) {
          btn.classList.add('is-active');
          anyToggleActive = true;
        }
      }
    });

    if (anyToggleActive) {
      var allBtn = document.querySelector('.toggle-filter-btn[data-filter-key="all"]');
      if (allBtn) {
        allBtn.classList.remove('is-active');
      }
    }
  }

  function bindToggleFilters() {
    var container = document.querySelector('[data-toggle-filters]');
    if (!container || container.dataset.toggleBound === 'true') return;

    container.addEventListener('click', function (event) {
      var btn = event.target.closest('.toggle-filter-btn');
      if (!btn) return;

      var key = btn.getAttribute('data-filter-key');

      // Block filter usage when no warehouse/state is selected (except "All" reset)
      if (key !== 'all' && !isWarehouseSelected()) {
        scrollToMap();
        showMapTooltip();
        return;
      }

      if (key === 'all') {
        // "All" clears all other toggles
        container.querySelectorAll('.toggle-filter-btn').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      } else {
        // Toggle the clicked button
        btn.classList.toggle('is-active');

        // Remove "All" active state
        var allBtn = container.querySelector('[data-filter-key="all"]');
        if (allBtn) {
          allBtn.classList.remove('is-active');
        }

        // If no toggles active, re-activate "All"
        var anyActive = container.querySelectorAll('.toggle-filter-btn.is-active');
        if (anyActive.length === 0 && allBtn) {
          allBtn.classList.add('is-active');
        }
      }

      // Apply filters to all option grids
      document.querySelectorAll('.option_grid').forEach(function (scope) {
        applyCombinedFiltersWithToggles(scope);
      });
    });

    container.dataset.toggleBound = 'true';
  }

  window.initFacetsDetails = function (container) {
    const scope = getOptionGrid(container);
    if (!scope) return;

    bindFilterDrawer(scope);
    bindCheckboxFilters(scope);
    bindToggleFilters();
  };

  function initAllFilters() {
    restoreTogglesFromURL();
    bindToggleFilters();

    document.querySelectorAll('.filter-facets-section').forEach((container) => {
      window.initFacetsDetails(container);
    });

    bindMapFilter();
    updateAddToCartLockState();
    bindAtcLockInterceptor();
  }

  document.addEventListener('facets:reloaded', function (event) {
    (event.detail.containers || []).forEach((container) => {
      window.initFacetsDetails(container);
    });

    bindToggleFilters();
    bindMapFilter();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFilters, { once: true });
  } else {
    initAllFilters();
  }
})();
